import { CreateFileSystemModule } from "./CreateFileSystemModule.js";

export { CreateFileSystemModule } from "./CreateFileSystemModule.js";

export { MUTATION_TYPES } from "./CreateFileSystemModule.js";

export const FileSystemModule = CreateFileSystemModule("/filesystem"); // backwards compatible Store.
